module.exports = __webpack_public_path__ + "img/vegas-quality-painting.acc53497.jpg";